import { useMemo } from 'react';
//[ToDo] remove ts-ignore
//@ts-ignore
import { MeduxProvider, MeduxMiddleware } from '@mindtickle/medux/Store';
//@ts-ignore
import { injectSaga } from '@mindtickle/medux/Saga';

import { compose } from 'recompose';

import { mixpanelRootSaga } from '~/components/Mixpanel';
import { useUserAuth } from '~/components/Auth';

const withRedux = <
  P extends { initialState?: { [key: string]: any }; middleware?: MeduxMiddleware }
>() => {
  const enhancer = (Component: React.ComponentType) => ({
    initialState = {},
    middleware,
    ...rest
  }: P) => {
    const userAuth = useUserAuth();

    const initialStateWithUserAuth = useMemo(() => ({ ...initialState, auth: userAuth }), [
      initialState,
      userAuth,
    ]);

    return (
      <MeduxProvider initialState={initialStateWithUserAuth} middleware={middleware}>
        <Component {...rest} />
      </MeduxProvider>
    );
  };
  const withSaga = injectSaga({ name: 'Mixpanel', saga: mixpanelRootSaga });

  return compose<P, P>(enhancer, withSaga);
};

export default withRedux;
